<style>
.anchor-sidebar-divider {
  margin: 20px 0;
}
</style>

<template>
  <v-divider class="anchor-sidebar-divider" />
</template>

<script>
export default {
  name: 'AnchorSidebarDivider',
};
</script>
